import { createFileRoute } from "@tanstack/react-router";
import { AccessoriesPage } from "@/components/products/AccessoriesPage";
import { accessoriesSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/accessories/")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => accessoriesSeo(loaderData?.href ?? "/products/accessories"),
  component: AccessoriesPage,
});
